import React, { useEffect, useState } from 'react';
import { Box, Grid, Button, Typography, TextField, Divider, FormControl, Select, MenuItem, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import CustomTable from '../../components/table/Table';
import { useDispatch, useSelector } from "react-redux";
import SearchButton from '../../components/search/Search';
import BasicTabs from '../../components/tabs/Tabs3';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ClearIcon from '@mui/icons-material/Clear';
import { createregion, createuser, getstate } from '../../slices/setting';
import { Navigate, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const Createuser = ({setLoader, show}) => {

  const [modules, setModules] = useState([
    {name:'Dashboard', checked: true}, 
    {name:'Enquiries', checked: true},
    {name:'Quotation', checked: true},
    {name:'Customers', checked: true}, 
    {name:'Inventory', checked: true},
    {name:'Purchases', checked: true}, 
    {name:'Delivery Challan', checked: true},
    {name:'Support', checked: true},
  ]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Validation schema using Yup
  const validationSchema = Yup.object({
    role: Yup.string().required('Role is required'),
    user_role: Yup.string().required('User role is required'),
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),
    contact: Yup.string()
      .matches(/^[0-9]{10}$/, 'Contact must be a 10-digit number')
      .required('Contact number is required'),
    password: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
      )
      .required('Password is required'),
    confirm_password: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Confirm password is required'),
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      role: "",
      user_role: "",
      first_name: "",
      last_name: "",
      email: "",
      contact: "",
      password: "",
      confirm_password: ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const userData = { ...values, modules: modules };
      setLoader(true);
      dispatch(createuser(userData))
        .then(() => {
          navigate("/usermanagement");
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
        });
    },
  });

  const arrowBack = () => {
    navigate(-1);
  };

  const handleModule = (event, name) => {
    const val = modules.map(va => {
      if(va.name === name) {
        return {...va, checked: event.target.checked}
      }
      return va
    })
    setModules(val);
  }

  return (
    <div className='content' style={{marginLeft: show ? '220px' : '10px'}}>
      <Box component="form"
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}>
        <Grid container spacing={3} sx={{ paddingBottom: 2, alignItems: "center" }}>
          <Grid
            item
            xs={12}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <ArrowBackIcon onClick={arrowBack} sx={{ cursor: "pointer" }} />
            <Typography variant="h5">Add User</Typography>
          </Grid>
          <Grid item xs={12} sx={{ paddingTop: 3 }}>
            <Grid container spacing={2} sx={{alignItems:'center'}}>
                <Grid item xs={2}>
                  <Typography>Select Role *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth size="small" sx={{ minWidth: 80 }}>
                    <Select
                      labelId="role-select-label"
                      id="role"
                      name="role"
                      value={formik.values.role}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.role && Boolean(formik.errors.role)}
                    >
                      <MenuItem value="Sales">Sales</MenuItem>
                      <MenuItem value="Accounts">Accounts</MenuItem>
                      <MenuItem value="Finance">Finance</MenuItem>
                      <MenuItem value="Production">Production</MenuItem>
                      <MenuItem value="Dispatch">Dispatch</MenuItem>
                      <MenuItem value="Service">Service</MenuItem>
                    </Select>
                    {formik.touched.role && formik.errors.role && (
                      <Typography color="error" variant="caption">
                        {formik.errors.role}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <Typography>User Role *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth size="small" sx={{ minWidth: 80 }}>
                    <Select
                      labelId="user-role-select-label"
                      id="user_role"
                      name="user_role"
                      value={formik.values.user_role}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.user_role && Boolean(formik.errors.user_role)}
                    >
                      <MenuItem value="Sales Person">Sales Person</MenuItem>
                      <MenuItem value="Sales Head">Sales Head</MenuItem>
                      <MenuItem value="Regional Head">Regional Head</MenuItem>
                      <MenuItem value="Zonal Head">Zonal Head</MenuItem>
                    </Select>
                    {formik.touched.user_role && formik.errors.user_role && (
                      <Typography color="error" variant="caption">
                        {formik.errors.user_role}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <Typography>First Name *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    fullWidth
                    id="first_name"
                    name="first_name"
                    variant="outlined"
                    value={formik.values.first_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                    helperText={formik.touched.first_name && formik.errors.first_name}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Typography>Last Name *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    fullWidth
                    id="last_name"
                    name="last_name"
                    variant="outlined"
                    value={formik.values.last_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                    helperText={formik.touched.last_name && formik.errors.last_name}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Typography>Email ID *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    fullWidth
                    id="email"
                    name="email"
                    variant="outlined"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Typography>Contact *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    fullWidth
                    id="contact"
                    name="contact"
                    variant="outlined"
                    value={formik.values.contact}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.contact && Boolean(formik.errors.contact)}
                    helperText={formik.touched.contact && formik.errors.contact}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Typography>Password *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    fullWidth
                    type="password"
                    id="password"
                    name="password"
                    variant="outlined"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Typography>Confirm Password *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    fullWidth
                    type="password"
                    id="confirm_password"
                    name="confirm_password"
                    variant="outlined"
                    value={formik.values.confirm_password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.confirm_password && Boolean(formik.errors.confirm_password)}
                    helperText={formik.touched.confirm_password && formik.errors.confirm_password}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='h6'>Modules</Typography>
                  <FormGroup sx={{mt: 2}}>
                    {modules.map((va, index) => {
                      return (
                        <FormControlLabel 
                          onChange={(event) => handleModule(event, va.name)} 
                          key={index} 
                          control={<Checkbox checked={va.checked} />} 
                          label={va.name} 
                        />    
                      )
                    })}
                  </FormGroup>
                </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{mt: 2}}>
          <Grid item xs={12} sx={{textAlign:'end'}}>
            <Button 
              sx={{mr: 2}} 
              variant="outlined" 
              onClick={() => navigate("/usermanagement")}
            >
              Cancel
            </Button>
            <Button 
              type="submit" 
              variant="contained"
            >
              Create New User
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Createuser;